// lib
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";

const checkboxGenerator = (color) =>
  withStyles({
    root: {
      color,
      "&$checked": {
        color,
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

const ColoredCheckbox = ({ color, ...rest }) => {
  const Component = checkboxGenerator(color);
  return <Component color="default" {...rest} />;
};

ColoredCheckbox.propTypes = {
  color: PropTypes.string,
};

ColoredCheckbox.defaultProps = {
  color: "#999",
};

export default ColoredCheckbox;
